export default __webpack_public_path__ + "static/race-day-pet-vertical-b5e48dfca31094bdc7842b985aacf330.png";